@if (page?.storyblokEditor) {
    <butterfly-editor-mode [content]="page.storyblokEditor"></butterfly-editor-mode>
}
@if (pageService.hasFailed$ | async) {
    <div class="page-gradient">
        <butterfly-error>{{ pageService.errorMessage }}</butterfly-error>
    </div>
} @else {
    @if (page) {
        <a
            class="butterfly-skip-link sir-text-style-link-m-default sir-text-style-color-primary"
            href="#main-content"
            (click)="onSkipToMain($event)"
            data-cy="skip-link">
            {{ 'a11y.skipToMainContent' | translate }}
        </a>

        <div class="page-gradient"></div>

        <butterfly-utility-bar-wrapper
            [content]="page.content"
            [culture]="page.culture"></butterfly-utility-bar-wrapper>
        <butterfly-navigation-wrapper [content]="page.content"></butterfly-navigation-wrapper>

        <main #mainContent id="main-content" class="sections" tabindex="-1">
            @for (cfg of page.content.body.rootComponent.body; track cfg) {
                <sirius-section [config]="cfg" [butterflyStoryblokEditable]="cfg.storyblokEditable"></sirius-section>
            }
        </main>
        <butterfly-footer-wrapper [config]="page.content" [culture]="page.culture"></butterfly-footer-wrapper>
    }
}
<ur-loading-spinner [show]="loadingSpinnerService.loading()"></ur-loading-spinner>
